// app/assets/javascripts/modals.js
import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
window.FilePond = FilePond;

$(document).on("turbolinks:load", function () {
  const modal_holder_selector = "#modal-holder";
  const modal_selector = ".modal";

  // Helper function to safely destroy Select2 only if it's initialized
  function safeDestroySelect2($element) {
    if ($element.length && $element.data('select2')) {
      try {
        $element.select2('destroy');
      } catch(e) {
        // Silently fail if destroy fails
      }
    }
  }

  $(document).on("click", "a[data-modal]", function () {
    const location = $(this).attr("href");
    // Load modal dialog from server
    $.get(location, (data) => {
      // Modal responses carry a different CSP nonce than the main page.
      // Replace them before jQuery's .html() processes the script tags,
      // since jQuery 3.5+ copies node.nonce via the private DOMEval().
      var nonceMeta = document.querySelector('meta[name="csp-nonce"]');
      if (nonceMeta && nonceMeta.content) {
        data = data.replace(/<script([^>]*)\snonce="[^"]*"/gi,
          '<script$1 nonce="' + nonceMeta.content + '"');
      }
      $(modal_holder_selector).html(data);
      const modalEl = document.querySelector('#modal-holder .modal');
      if (modalEl) {
        const bsModal = new bootstrap.Modal(modalEl);
        bsModal.show();
        modalEl.dispatchEvent(new CustomEvent('ark:modal:loaded', { bubbles: true }));
      }
      $(".select2").each(function(){
        safeDestroySelect2($(this));
        $(this).select2({
          theme: "bootstrap-5",
          width: '100%',
          minimumResultsForSearch: 0,
          dropdownParent: $('#modal-holder .modal:visible').length ? $('#modal-holder .modal:visible') : $(document.body)
        });
      });
      // datepicker
      flatpickr(".datepicker", {
        altInput: true,
        altFormat: "m/d/Y",
        dateFormat: "m/d/Y",
        allowInput: true,
      });
      flatpickr(".datetime_picker", {
        altInput: true,
        enableTime: true,
        allowInput: false,
        dateFormat: "m/d/Y H:i",
      });

      flatpickr(".time_picker", {
        enableTime: true,
        noCalendar: true,
        altInput: true,
        dateFormat: "m/d/Y H:i",
      });
      // dynamic dropdowns
      var $modalParent = $('#modal-holder .modal:visible');
      var $dropdownParent = $modalParent.length ? $modalParent : $(document.body);

      var $diocese = $(".diocese-select").select2({ 
        theme: "bootstrap-5",
        width: '100%',
        minimumResultsForSearch: 0,
        dropdownParent: $dropdownParent
      });
      var $testing_center = $(".testing-center-select").select2({
        theme: "bootstrap-5",
        width: '100%',
        minimumResultsForSearch: 0,
        dropdownParent: $dropdownParent
      });
      var $testing_window = $(".testing-window-select").select2({
        theme: "bootstrap-5",
      });
      var $testing_center_testing_window = $(
        ".testing-center-testing-window-select"
      ).select2({ theme: "bootstrap-5" });
      var $testing_center_testing_window_assessment = $(
        ".testing-center-testing-window-assessment-select"
      ).select2({ theme: "bootstrap-5" });
      var $testing_center_testing_window_assessment_with_grade = $(
        ".testing-center-testing-window-assessment-with-grade-select"
      ).select2({ theme: "bootstrap-5" });
      var $assessment_window = $(".assessment-window-select").select2({
        theme: "bootstrap-5",
      })
      $(".students-s").select2({
        theme: "bootstrap-5",
      });
      $diocese.on("select2:select", function (e) {
        $.ajax({
          method: "GET",
          data: { diocese: $(this).val() },
          url: "/admin/centers_list",
        }).done(function (resp) {
          $(".testing-center-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $testing_center.append(option);
          });
          $(".testing-center-select").trigger("change");
          $(".testing-center-select").val(null).trigger("change");
        });
      });
      $diocese.on("select2:select", function (e) {
        $.ajax({
          method: "GET",
          data: { diocese: $(this).val() },
          url: "/admin/diocese_testing_windows",
        }).done(function (resp) {
          $(".testing-window-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $testing_window.append(option);
          });
          $(".testing-window-select").trigger("change");
          $(".testing-window-select").val(null).trigger("change");
        });
      });
      $testing_center.on("select2:select", function (e) {
        $.ajax({
          method: "GET",
          data: { testing_center: $(this).val() },
          url: "/admin/testing_center_testing_windows",
        }).done(function (resp) {
          $(".testing-center-testing-window-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $testing_center_testing_window.append(option);
          });
          $(".testing-center-testing-window-select").trigger("change");
          $(".testing-center-testing-window-select")
            .val(null)
            .trigger("change");
        });
      });
      $testing_center.on("select2:select", function (e) {
        $.ajax({
          method: 'GET',
          data: { testing_center: $(this).val() },
          url: '/admin/testing_center_subject_areas',
        }).done(function (resp) {
          $('.school_class_subject_area_ids').empty();
          $('.testing_section_subject_area_ids').empty();
          $('#subjectAreaSection').empty();
          $('#assessmentsSection').hide();
          $('#assessment-selects').hide().empty();
          
          $('.school_class_subject_area_ids').append(
            '<label class="subject-areas-label">Subject Areas *</label>'
          );
          if (resp.length > 0) {
            $('#subjectAreaSection').append('<div class="col"><label class="subject-areas-label">Subject Areas *</label></div>');
          }
          
          $.each(resp, function (i, value) {
            $('.school_class_subject_area_ids').append(
              `<label class="checkbox" style="display: block;">
                <input type="checkbox" name="school_class[subject_area_ids][]" value="${value.id}">
                ${value.name}
              </label>`
            );
            if (resp.length > 0) {
              $('#subjectAreaSection .col').append(
                `<label class="checkbox" style="display: block;">
                  <input type="checkbox" name="testing_section[subject_area_ids][]" value="${value.id}" class="subject-area-checkbox">
                  ${value.name}
                </label>`
              );
            }
          });
        });
      });
      $(".students-s, .testing-center-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_center: $(this).val() },
          url: "/admin/testing_center_assessment",
        }).done(function (resp) {
          $(".testing-center-assessment").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $(".testing-center-assessment").append(option);
          });
          $(".testing-center-assessment").trigger("change");
          $(".testing-center-assessment").val(null).trigger("change");
        });
      });
      $(".testing-window-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_window: $(this).val() },
          url: "/admin/testing_window_assessments",
        }).done(function (resp) {
          $(".testing-center-assessment").empty().trigger("change");
          $(".testing-section-assessment").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $(".testing-center-assessment").append(option);
            $(".testing-section-assessment").append(option);
          });
          $(".testing-center-assessment").trigger("change");
          $(".testing-section-assessment").trigger("change");
          $(".testing-center-assessment").val(null).trigger("change");
          $(".testing-section-assessment").val(null).trigger("change");
        });
      });

      $(".testing-center-testing-window-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_center_testing_window: $(this).val() },
          url:
            "/admin/testing_center_testing_window_assessments?grade_level=" +
            $(this)[0].getAttribute("grade-level"),
        }).done(function (resp) {
          $testing_center_testing_window_assessment.empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $testing_center_testing_window_assessment.append(option);
          });
          $("testing-center-testing-window-assessment-select").trigger(
            "change"
          );
        });
      });

      $(".testing-center-testing-window-with-grade-select").on(
        "change",
        function () {
          $.ajax({
            method: "GET",
            data: { testing_center_testing_window: $(this).val() },
            url:
              "/admin/testing_center_testing_window_assessments_with_grade?grade_level=" +
              $(this)[0].getAttribute("grade-level"),
          }).done(function (resp) {
            $testing_center_testing_window_assessment_with_grade
              .empty()
              .trigger("change");
            // create the option and append to Select2
            $.each(resp, function (i, value) {
              var option = new Option(value.text, value.id, true, true);
              $testing_center_testing_window_assessment_with_grade.append(
                option
              );
            });
            $(
              "testing-center-testing-window-assessment-with-grade-select"
            ).trigger("change");
          });
        }
      );

      // Helper: re-init a Select2 with dropdownParent bound to active modal
      function reinitSelect2WithModalParent(selector) {
        var $el = $(selector);
        if (!$el.length) return;
        safeDestroySelect2($el);
        var $modal = $('#modal-holder .modal:visible');
        $el.select2({
          theme: "bootstrap-5",
          width: '100%',
          dropdownParent: $modal.length ? $modal : $(document.body)
        });
      }

      $(".publisher-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { publisher: $(this).val() },
          url: "/admin/publisher_material",
        }).done(function (resp) {
          $(".material-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, false, false);
            $(".material-select").append(option);
          });
          $(".material-select").val(null).trigger("change");
          // Reinitialize with modal parent to ensure proper stacking and scroll
          reinitSelect2WithModalParent('.material-select');
        });
      });

      $(".second-publisher-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { publisher: $(this).val() },
          url: "/admin/publisher_material",
        }).done(function (resp) {
          $(".second-material-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, false, false);
            $(".second-material-select").append(option);
          });
          $(".second-material-select").val(null).trigger("change");
          // Reinitialize with modal parent to ensure proper stacking and scroll
          reinitSelect2WithModalParent('.second-material-select');
        });
      });

      $(".material-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { material: $(this).val() },
          url: "/admin/material_edition",
        }).done(function (resp) {
          $(".edition-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, false, false);
            $(".edition-select").append(option);
          });
          $(".edition-select").val(null).trigger("change");
          // Reinitialize with modal parent to ensure proper stacking and scroll
          reinitSelect2WithModalParent('.edition-select');
        });
      });

      $(".second-material-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { material: $(this).val() },
          url: "/admin/material_edition",
        }).done(function (resp) {
          $(".second-edition-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, false, false);
            $(".second-edition-select").append(option);
          });
          $(".second-edition-select").val(null).trigger("change");
          // Reinitialize with modal parent to ensure proper stacking and scroll
          reinitSelect2WithModalParent('.second-edition-select');
        });
      });

      // select on create class page for teachers
      $(".testing-center-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_center: $(this).val() },
          url: "/admin/teachers_by_testing_center",
        }).done(function (resp) {
          $(".teachers_filter").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $(".teachers_filter").append(option);
          });
          $(".teachers_filter").trigger("change");
          $(".teachers_filter").val(null).trigger("change");
        });
      });

      $(".testing-center-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_center: $(this).val() },
          url: "/admin/proctors_by_testing_center",
        }).done(function (resp) {
          $(".proctors_filter").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $(".proctors_filter").append(option);
          });
          $(".proctors_filter").trigger("change");
          $(".proctors_filter").val(null).trigger("change");
        });
      });

      $(".testing-center-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_center: $(this).val() },
          url: "/admin/testing_center_allow_pre_test",
        }).done(function (resp) {
          if (resp == true) {
            $("#testing_section_pre_test")
              .removeClass("disabled")
              .removeAttr("disabled");
            $("#testing_section_pre_test + label").removeClass("disabled");
            $(".testing_section_pre_test").removeClass("disabled");
          } else {
            $("#testing_section_pre_test")
              .addClass("disabled")
              .prop("checked", false)
              .attr("disabled", "disabled");
            $("#testing_section_pre_test + label").addClass("disabled");
            $(".testing_section_pre_test").addClass("disabled");
          }
        });
      });

      $(".testing-center-select").on("change", function () {
        $.ajax({
          method: "GET",
          data: { testing_center: $(this).val() },
          url: "/admin/grade_levels_by_testing_center",
        }).done(function (resp) {
          $(".grade-level-select").empty().trigger("change");
          // create the option and append to Select2
          $.each(resp, function (i, value) {
            var option = new Option(value.text, value.id, true, true);
            $(".grade-level-select").append(option);
          });
          $(".grade-level-select").trigger("change");
          $(".grade-level-select").val(null).trigger("change");
        });
      });

      $(".testing-center-select").on("change", function () {
        $.get("/admin/testing_center_current_year", {
          testing_center: $(this).val(),
        }).done(function (res) {
          $("#current_year").html(res);
        });
      });

      $assessment_window.on("select2:select", function (e) {
        $.ajax({
          method: "GET",
          data: { assessment_window: $(this).val() },
          url: "/admin/assessment_window_dates",
        }).done(function (resp) {
          start_date = new Date(resp.start_date);
          start_date.setDate(start_date.getDate() + 1);

          end_date = new Date(resp.end_date);
          end_date.setDate(end_date.getDate() + 1);

          const $fp_start_date = flatpickr("#start-date", {
            dateFormat: "d-M-Y",
            minDate: start_date,
            maxDate: end_date
          });
          const $fp_end_date = flatpickr("#end-date", {
            dateFormat: "d-M-Y",
            minDate: start_date,
            maxDate: end_date
          });

          $fp_start_date.setDate(start_date);
          $fp_end_date.setDate(end_date);
        });
      });

      $(".validate").validate();
      $("input[type='radio']").on("click", function () {
        var radioValue = $(
          "input[name='assessment[is_teacher]']:checked"
        ).val();
        if (radioValue == "true") {
          $(".assessment_grade_level").addClass("d-none");
        } else if (radioValue == "false") {
          $(".assessment_grade_level").removeClass("d-none");
        }
      });

      var url = "/admin/file_upload";
      const addtionalFile = document.querySelector(".file_upload");
      FilePond.registerPlugin(FilePondPluginFileValidateType);
      const addpond = FilePond.create(addtionalFile, {
        multiple: false,
        allowFileTypeValidation: true,
        acceptedFileTypes: ["text/csv", "application/csv"],
        server: {
          process: (
            fieldName,
            file,
            metadata,
            load,
            error,
            progress,
            abort,
            transfer,
            options
          ) => {
            document.getElementById("upload_error").innerHTML = "";
            const formData = new FormData();
            formData.append("filepond", file, file.name);
            formData.append("importable_type", $(".importable_type").val());
            formData.append(
              "importable_id",
              $("#user_testing_center_id").val()
            );
            const windowIdSelect = document.querySelector(".window_id_select");
            if (windowIdSelect) {
              formData.append("window_id", windowIdSelect.value);
            }

            const request = new XMLHttpRequest();
            request.open("POST", url);
            request.upload.onprogress = (e) => {
              progress(e.lengthComputable, e.loaded, e.total);
            };
            request.onload = function () {
              if (request.status >= 200 && request.status < 300) {
                try {
                  const response = JSON.parse(request.responseText);
                  
                  if (response.redirect_to) {
                    $('.modal').modal('hide');
                    $('.modal-backdrop').remove();
                    window.location.href = response.redirect_to;
                    return;
                  }
                } catch (e) {}
                
                $(".import_body").html(request.responseText);
                $(".import_form").validate();
                load(request.responseText);
              } else {
                error("oh no");
                console.log("error");
                const errorContainer = $("#upload_error");

                if (errorContainer.length) {
                  errorContainer.html(request.responseText).show();
                }
              }
            };

            request.send(formData);

            return {
              abort: () => {
                request.abort();

                abort();
              },
            };
          },
        },
      });
    });

    return false;
  });

  $(document).on("ajax:success", "form[data-modal]", function (event) {
    const [data, _status, xhr] = event.detail;
    const url = xhr.getResponseHeader("Location");
    if (url) {
      // Redirect to url
      window.location = url;
    } else {
      // Remove old modal backdrop
      //$('.modal-backdrop').remove();
      // Update modal content
      console.log(data);
      // const modal = $(data).find('body').html();
      // $(modal_holder_selector).html(modal).find(modal_selector).modal();
      $(".resp").html("");
      $(".resp").html(data.resp);
      $(".simple_form").trigger("reset");
      $('#students-table').replaceWith(data.students_table);
      if (data.type == "students-s") {
        $(".students-s").empty().trigger("change");
        // create the option and append to Select2
        $.each(data.result, function (i, value) {
          var option = new Option(value.name, value.id, true, true);
          $(".students-s").append(option);
        });
      }
      $(".select2").trigger("change");
      $(".select2").val("").trigger("change");
    }

    return false;
  });
  
  $(document).on("hidden.bs.modal", "#mainModal", function (e) {
    $(".modal-backdrop").remove();
  });

  // Initialize modal content when shown
  // Reinitialize Select2 for any modal injected into #modal-holder
  $(document).on("shown.bs.modal", "#modal-holder .modal", function (e) {
    console.log('Modal shown, checking for testing section modal');
    
    // Skip if this is the school class duplication modal
    if ($('#schoolClassSubjectAreaSection').hasClass('duplicate-modal-specific')) {
      console.log('Skipping modal.js initialization for school class duplication modal');
      return;
    }
    
    // Ensure any Select2 inside the modal is initialized with the modal as dropdown parent
    try {
      var $modal = $(this);
      if ($modal.length) {
        $modal.find('select.select2').each(function() {
          safeDestroySelect2($(this));
          $(this).select2({
            theme: "bootstrap-5",
            width: '100%',
            minimumResultsForSearch: 0,
            dropdownParent: $modal
          });
        });
      }
    } catch(err) { console.warn('Select2 modal reinit failed', err); }

    // Check if we're in a testing section modal
    const subjectAreaSection = $('#subjectAreaSection');
    if (subjectAreaSection.length) {
      const isEditMode = subjectAreaSection.data('edit-mode') === true;
      const testingCenterId = subjectAreaSection.data('testing-center-id') || 
                             $('.testing-center-select').val() || 
                             $('#testing_section_testing_center_id').val() ||
                             $('input[name="testing_section[testing_center_id]"]').val();
      const subjectAreaIds = subjectAreaSection.data('subject-area-ids');
      const sectionOpened = subjectAreaSection.data('section-opened') === true;
      
      console.log('Testing section modal detected:', {
        isEditMode: isEditMode,
        testingCenterId: testingCenterId,
        subjectAreaIds: subjectAreaIds,
        sectionOpened: sectionOpened
      });
      
      if (testingCenterId && isEditMode) {
        // Load subject areas for edit mode
        $.ajax({
          method: 'GET',
          data: { testing_center: testingCenterId },
          url: '/admin/testing_center_subject_areas',
        }).done(function (resp) {
          console.log('Subject areas loaded for edit:', resp);
          $('#subjectAreaSection').empty();
          
          if (resp.length > 0) {
            $('#subjectAreaSection').append('<div class="col"><label class="subject-areas-label">Subject Areas *</label></div>');
            
            // Add warning message if section has been opened
            if (sectionOpened) {
              $('#subjectAreaSection .col').append(
                `<div class="text-muted small mb-2">
                  <i class="fas fa-lock mr-1"></i>
                  Subject areas cannot be changed because this testing section has already been opened
                </div>`
              );
            }
            
            $.each(resp, function (i, value) {
              var isChecked = subjectAreaIds && subjectAreaIds.includes(value.id) ? 'checked' : '';
              var isDisabled = sectionOpened ? 'disabled' : '';
              var labelClass = sectionOpened ? 'text-muted' : '';
              $('#subjectAreaSection .col').append(
                `<label class="checkbox ${labelClass}" style="display: block;">
                  <input type="checkbox" name="testing_section[subject_area_ids][]" value="${value.id}" class="subject-area-checkbox" ${isChecked} ${isDisabled}>
                  ${value.name}
                </label>`
              );
            });
            
            // Disable grade level select if section has been opened
            if (sectionOpened) {
              const $gradeSelect = $('.grade-level-select');
              $gradeSelect.prop('disabled', true);
              // Add visual indicator
              const $gradeLabel = $gradeSelect.closest('.form-group').find('label');
              if ($gradeLabel.length && !$gradeLabel.find('.fa-lock').length) {
                $gradeLabel.append(' <i class="fas fa-lock text-muted ml-1" title="Cannot change grade level - section already opened"></i>');
              }
            }
            
            // Trigger assessment loading if grade level is already selected
            setTimeout(function() {
              const gradeLevel = $('.grade-level-select').val() || $('#testing_section_grade_level').val();
              if (gradeLevel && $('.subject-area-checkbox:checked').length > 0) {
                console.log('Triggering updateAssessments for edit mode with existing data');
                console.log('Grade level:', gradeLevel);
                console.log('Checked subject areas:', $('.subject-area-checkbox:checked').length);
                window.updateAssessments();
              }
            }, 300);
          }
        });
      } else if (testingCenterId && !isEditMode) {
        // Handle case where we have testing center but not in edit mode (e.g., center_admin creation)
        console.log('Non-edit mode with testing center detected, loading subject areas');
        $.ajax({
          method: 'GET',
          data: { testing_center: testingCenterId },
          url: '/admin/testing_center_subject_areas',
        }).done(function (resp) {
          console.log('Subject areas loaded for creation:', resp);
          $('#subjectAreaSection').empty();
          
          if (resp.length > 0) {
            $('#subjectAreaSection').append('<div class="col"><label class="subject-areas-label">Subject Areas *</label></div>');
            
            $.each(resp, function (i, value) {
              // Hide Theology for Kindergarten and First Grade
              const gradeLevel = $('.grade-level-select').val() || $('#testing_section_grade_level').val();
              const isKOrFirst = gradeLevel === 'kindergarten' || gradeLevel === 'first' || gradeLevel === '0' || gradeLevel === '1';
              
              if (isKOrFirst && value.id === 1) {
                console.log('Hiding Theology for K/1 grade in modals.js');
                return; // Skip Theology for K/1
              }
              
              $('#subjectAreaSection .col').append(
                `<label class="checkbox" style="display: block;">
                  <input type="checkbox" name="testing_section[subject_area_ids][]" value="${value.id}" class="subject-area-checkbox">
                  ${value.name}
                </label>`
              );
            });
          }
        });
      }
    }
  });

  // Ensure Select2 search input is enabled and focused inside modals when opened
  $(document).on('select2:open', function (e) {
    var $openContainer = $('.select2-container--open');
    if (!$openContainer.length) return;
    var $search = $openContainer.find('.select2-search__field');
    // Force-enable and focus the search box
    $search.prop('disabled', false)
           .prop('readonly', false)
           .attr('tabindex', 0)
           .css('pointer-events', 'auto')
           .focus();
    // Prevent Bootstrap modal focus trap from stealing focus
    $search.on('keydown keypress keyup', function(ev){ ev.stopPropagation(); });
  });

  // Function to update assessments based on selected subject areas and grade level
  window.updateAssessments = function() {
    // Skip if this is the school class duplication modal
    if ($('#schoolClassSubjectAreaSection').hasClass('duplicate-modal-specific')) {
      console.log('Skipping updateAssessments for school class duplication modal');
      return;
    }
    
    const selectedSubjectAreas = [];
    $('.subject-area-checkbox:checked').each(function() {
      selectedSubjectAreas.push($(this).val());
    });
    
    // Try multiple selectors for testing center ID
    const testingCenterId = $('.testing-center-select').val() || 
                           $('#testing_section_testing_center_id').val() ||
                           $('input[name="testing_section[testing_center_id]"]').val() ||
                           $('select[name="testing_section[testing_center_id]"]').val() ||
                           $('#subjectAreaSection').data('testing-center-id');
    const gradeLevel = $('.grade-level-select').val() || $('#testing_section_grade_level').val();
    const isPaperTest = $('#testing_section_is_paper_test').is(':checked');
    
    console.log('Parameters:', {
      selectedSubjectAreas: selectedSubjectAreas,
      testingCenterId: testingCenterId,
      gradeLevel: gradeLevel,
      isPaperTest: isPaperTest
    });
    
    // Debug: log all possible selectors
    console.log('Debug selectors:', {
      'testing-center-select': $('.testing-center-select').val(),
      'testing_section_testing_center_id': $('#testing_section_testing_center_id').val(),
      'input name selector': $('input[name="testing_section[testing_center_id]"]').val(),
      'select name selector': $('select[name="testing_section[testing_center_id]"]').val(),
      'data attribute': $('#subjectAreaSection').data('testing-center-id'),
      'all testing center selects': $('select').filter(function() { return this.name && this.name.includes('testing_center'); }).map(function() { return {name: this.name, value: this.value}; }).get()
    });
    
    if (selectedSubjectAreas.length > 0 && testingCenterId && gradeLevel) {
      console.log('Making AJAX call to get assessments');
      
      // Check if we're in tab mode (testing windows exist)
      let $activePane = $('.tab-pane.show.active');
      if ($activePane.length === 0) {
        $activePane = $('.tab-pane.active');
      }
      const hasTabs = $activePane.length > 0;
      const tctwId = hasTabs ? $activePane.data('window-id') : null;
      
      // Store current selections before clearing (if we're switching tabs)
      if (hasTabs && tctwId) {
        // Save current selections from the active tab before switching
        const currentSelections = {};
        $activePane.find('.assessment-select').each(function() {
          const $select = $(this);
          const subjectAreaId = $select.data('subject-area-id');
          const selectedValue = $select.val();
          if (subjectAreaId && selectedValue) {
            currentSelections[subjectAreaId] = selectedValue;
          }
        });
        
        // Store in a data attribute on the pane for persistence
        if (Object.keys(currentSelections).length > 0) {
          $activePane.data('stored-selections', currentSelections);
          console.log('Stored selections for window', tctwId, ':', currentSelections);
        }
      }
      
      console.log('Tab detection - Active pane:', $activePane.length, 'Has tabs:', hasTabs, 'TCTW ID:', tctwId);
      
      // Determine target container
      let $targetContainer;
      if (hasTabs) {
        // Try multiple strategies to find the container
        $targetContainer = $activePane.find('.assessment-selects .assessment-content');
        console.log('Strategy 1 - .assessment-content:', $targetContainer.length);
        
        if ($targetContainer.length === 0) {
          $targetContainer = $activePane.find('.assessment-selects .col-12');
          console.log('Strategy 2 - .col-12:', $targetContainer.length);
        }
        
        if ($targetContainer.length === 0) {
          // Try finding the row first
          const $row = $activePane.find('.row.assessment-selects');
          console.log('Strategy 3 - Finding row:', $row.length);
          if ($row.length > 0) {
            // Check if it has a col-12
            $targetContainer = $row.find('.col-12');
            if ($targetContainer.length === 0) {
              // Create container if it doesn't exist
              $targetContainer = $('<div class="col-12 assessment-content"></div>');
              $row.append($targetContainer);
              console.log('Created new container');
            }
          }
        }
        
        // Last resort: create the entire structure
        if ($targetContainer.length === 0) {
          console.log('Creating full container structure');
          const $row = $('<div class="row assessment-selects"></div>');
          $targetContainer = $('<div class="col-12 assessment-content"></div>');
          $row.append($targetContainer);
          $activePane.append($row);
        }
      } else {
        $targetContainer = $('#assessment-selects');
        console.log('No tabs mode - Container:', $targetContainer.length);
      }
      
      if ($targetContainer.length === 0) {
        console.error('Assessment container not found after all attempts');
        console.error('Active pane HTML:', $activePane.length > 0 ? $activePane.html().substring(0, 500) : 'No active pane');
        return;
      }
      
      console.log('Container found successfully:', $targetContainer.length, 'Container classes:', $targetContainer.attr('class'));
      
      // Show loading message - ensure container is visible
      $targetContainer.css('display', 'block').show();
      
      // If it's a row, also ensure the col-12 inside is visible
      if ($targetContainer.hasClass('row')) {
        const $col = $targetContainer.find('.col-12.assessment-content, .col-12');
        if ($col.length > 0) {
          $col.css('display', 'block').show();
        }
      }
      
      // Set loading message in the content container
      let $loadingContainer = $targetContainer;
      if ($targetContainer.hasClass('row')) {
        $loadingContainer = $targetContainer.find('.col-12.assessment-content, .col-12');
        if ($loadingContainer.length === 0) {
          $loadingContainer = $targetContainer;
        }
      }
      $loadingContainer.html('<div class="text-muted pl-3 pt-2">Loading assessments...</div>');
      
      $.ajax({
        method: 'GET',
        data: {
          subject_area_ids: selectedSubjectAreas,
          testing_center_id: testingCenterId,
          grade_level: gradeLevel,
          is_paper_test: isPaperTest,
          testing_center_testing_window_id: tctwId
        },
        url: '/admin/testing_sections/assessment_options',
      }).done(function(resp) {
        console.log('Assessments response:', resp);
        
        // Determine the correct content container - if $targetContainer is a row, use its col-12
        let $contentContainer = $targetContainer;
        if ($targetContainer.hasClass('row')) {
          $contentContainer = $targetContainer.find('.col-12.assessment-content');
          if ($contentContainer.length === 0) {
            $contentContainer = $targetContainer.find('.col-12');
          }
          if ($contentContainer.length === 0) {
            // Create it if it doesn't exist
            $contentContainer = $('<div class="col-12 assessment-content"></div>');
            $targetContainer.append($contentContainer);
          }
        }
        
        console.log('Content container:', $contentContainer.length, 'Classes:', $contentContainer.attr('class'));
        $contentContainer.empty().css('display', 'block').show();
        
        // Also ensure the parent row is visible
        if ($targetContainer.hasClass('row')) {
          $targetContainer.css('display', 'flex').show();
        }
        
        if (resp.assessments && resp.assessments.length > 0) {
          // Check for stored selections from previous tab switches
          let storedSelections = null;
          if (hasTabs && $activePane.length > 0) {
            storedSelections = $activePane.data('stored-selections');
            if (storedSelections) {
              console.log('Found stored selections for this tab:', storedSelections);
            }
          }
          
          // Check if we're in edit mode and get the selected assessment IDs
          const testingSectionId = $('#subjectAreaSection').data('testing-section-id');
          
          if (testingSectionId) {
            // Get selected assessment IDs from the new endpoint
            $.ajax({
              method: 'GET',
              data: { testing_section_id: testingSectionId },
              url: '/admin/get_testing_section_assessments',
            }).done(function(selectedResp) {
              console.log('Selected assessment IDs response:', selectedResp);
              let selectedAssessmentIds = selectedResp.assessment_ids || [];
              
              // If we have stored selections, merge them (stored takes precedence for this tab)
              if (storedSelections) {
                // Convert stored selections object to array of IDs
                selectedAssessmentIds = Object.values(storedSelections).map(id => parseInt(id));
                console.log('Using stored selections:', selectedAssessmentIds);
              }
              
              window.renderAssessmentSelects(resp.assessments, selectedAssessmentIds, $contentContainer, storedSelections);
            }).fail(function() {
              // If the call fails, use stored selections if available
              const selectedAssessmentIds = storedSelections ? Object.values(storedSelections).map(id => parseInt(id)) : [];
              window.renderAssessmentSelects(resp.assessments, selectedAssessmentIds, $contentContainer, storedSelections);
            });
          } else {
            // New testing section - use stored selections if available
            const selectedAssessmentIds = storedSelections ? Object.values(storedSelections).map(id => parseInt(id)) : [];
            window.renderAssessmentSelects(resp.assessments, selectedAssessmentIds, $contentContainer, storedSelections);
          }
        } else {
          console.log('No assessments found');
          $contentContainer.html('<div class="text-muted pl-3 pt-2">No assessments available for this selection.</div>');
          if (!hasTabs) {
            $('#assessmentsSection').hide();
          }
        }
      }).fail(function(xhr, status, error) {
        console.error('AJAX error:', error);
        console.error('Response:', xhr.responseText);
        let $errorContainer = $targetContainer.hasClass('row') ? $targetContainer.find('.col-12.assessment-content') : $targetContainer;
        if ($errorContainer.length === 0) $errorContainer = $targetContainer;
        $errorContainer.html('<div class="text-danger pl-3 pt-2">Failed to load assessments.</div>');
      });
    } else {
      console.log('Missing required parameters, hiding assessments');
      // Hide all assessment containers
      $('.assessment-selects .assessment-content').empty();
      $('#assessment-selects').empty().hide();
      if (!$('.tab-pane.show.active').length) {
        $('#assessmentsSection').hide();
      }
    }
  }

  // Event listeners for testing sections functionality
  $(document).on('change', '.subject-area-checkbox', function() {
    // Skip if this is the school class duplication modal
    if ($('#schoolClassSubjectAreaSection').hasClass('duplicate-modal-specific')) {
      return;
    }
    
    // Prevent changes if section has already been opened
    const sectionOpened = $('#subjectAreaSection').data('section-opened') === true;
    if (sectionOpened) {
      console.log('Subject area change prevented - section already opened');
      // Revert the checkbox state
      $(this).prop('checked', !$(this).prop('checked'));
      return;
    }
    
    window.updateAssessments();
  });

  // Function to re-render subject areas based on grade level
  window.rerenderSubjectAreas = function() {
    const testingCenterId = $('.testing-center-select').val() || 
                           $('#testing_section_testing_center_id').val() ||
                           $('#subjectAreaSection').data('testing-center-id');
    
    if (testingCenterId) {
      $.ajax({
        method: 'GET',
        data: { testing_center: testingCenterId },
        url: '/admin/testing_center_subject_areas',
      }).done(function (resp) {
        $('#subjectAreaSection').empty();
        
        if (resp.length > 0) {
          $('#subjectAreaSection').append('<div class="col"><label class="subject-areas-label">Subject Areas *</label></div>');
          
          $.each(resp, function (i, value) {
            // Hide Theology for Kindergarten and First Grade
            const gradeLevel = $('.grade-level-select').val() || $('#testing_section_grade_level').val();
            const isKOrFirst = gradeLevel === 'kindergarten' || gradeLevel === 'first' || gradeLevel === '0' || gradeLevel === '1';
            
            if (isKOrFirst && value.id === 1) {
              console.log('Hiding Theology for K/1 grade in modals.js (rerender)');
              return; // Skip Theology for K/1
            }
            
            $('#subjectAreaSection .col').append(
              `<label class="checkbox" style="display: block;">
                <input type="checkbox" name="testing_section[subject_area_ids][]" value="${value.id}" class="subject-area-checkbox">
                ${value.name}
              </label>`
            );
          });
        }
      });
    }
  };

  $(document).on('change', '.grade-level-select', function() {
    // Skip if this is the school class duplication modal
    if ($('#schoolClassSubjectAreaSection').hasClass('duplicate-modal-specific')) {
      return;
    }
    
    // Prevent changes if section has already been opened
    const sectionOpened = $('#subjectAreaSection').data('section-opened') === true;
    if (sectionOpened) {
      console.log('Grade level change prevented - section already opened');
      return;
    }
    
    window.rerenderSubjectAreas(); // Re-render subject areas first
    window.updateAssessments();
  });

  $(document).on('change', '#testing_section_is_paper_test', function() {
    // Skip if this is the school class duplication modal
    if ($('#schoolClassSubjectAreaSection').hasClass('duplicate-modal-specific')) {
      return;
    }
    window.updateAssessments();
  });

  // Helper function to render assessment selects
  window.renderAssessmentSelects = function(assessments, selectedAssessmentIds, $container, storedSelections) {
    console.log('Rendering assessment selects with selected IDs:', selectedAssessmentIds, 'Stored selections:', storedSelections);
    
    // Use provided container or fallback to default
    const $targetContainer = $container || $('#assessment-selects');
    if ($targetContainer.length === 0) {
      console.error('Container not provided or not found');
      return;
    }
    
    // Clear the container completely before rendering to avoid layout issues
    $targetContainer.empty();
    
    // Ensure the container has proper display and structure
    $targetContainer.css({
      'display': 'block',
      'width': '100%'
    }).show();
    
    // Check if this is a past window (for edit mode)
    const $parentTabPane = $targetContainer.closest('.tab-pane');
    const isPastWindow = $parentTabPane.length > 0 && $parentTabPane.data('is-past') === true;
    
    // Check if this specific window has a status record (window-specific lock)
    const hasStatusForWindow = $parentTabPane.length > 0 && $parentTabPane.data('has-status') === true;
    
    // Disable if it's a past window OR if this specific window has a status record
    const disabledAttr = (isPastWindow || hasStatusForWindow) ? 'disabled' : '';
    const labelClass = (isPastWindow || hasStatusForWindow) ? 'text-muted' : '';
    
    console.log('Rendering assessments. isPastWindow:', isPastWindow, 'hasStatusForWindow:', hasStatusForWindow);
    // Get currently selected subject areas
    const selectedSubjectAreas = [];
    const $modalScope = $targetContainer.closest('.modal').length ? $targetContainer.closest('.modal') : $(document);
    $modalScope.find('.subject-area-checkbox:checked').each(function() {
      selectedSubjectAreas.push(parseInt($(this).val()));
    });
    
    console.log('Selected subject areas:', selectedSubjectAreas);
    
    // Group assessments by subject area
    const assessmentsBySubject = {};
    assessments.forEach(function(assessment) {
      if (!assessmentsBySubject[assessment.subject_area_id]) {
        assessmentsBySubject[assessment.subject_area_id] = {
          name: assessment.subject_area_name,
          assessments: []
        };
      }
      assessmentsBySubject[assessment.subject_area_id].assessments.push(assessment);
    });
    
    // Add warning message if this specific window is locked
    if (hasStatusForWindow) {
      $targetContainer.append(`
        <div class="col-12 mb-2">
          <div class="text-muted small mb-2">
            <i class="fas fa-lock mr-1"></i>
            Assessments cannot be changed because this testing section has already been opened for this window
          </div>
        </div>
      `);
    }
    
    // Subject area names mapping
    const SUBJECT_NAMES = { 1: 'Theology', 2: 'Reading', 3: 'Math' };
    
    // Check if this is a MOY tab - if so, exclude Theology (subject_area_id = 1) unless teacher grade
    const $pane = $targetContainer.closest('.tab-pane');
    const isMoyTab = $pane.length > 0 && $pane.data('window-type') === 'MOY';
    const gradeLevel = $modalScope.find('.grade-level-select').val() || $modalScope.find('#testing_section_grade_level').val();
    const isTeacherGrade = gradeLevel === 'teacher' || gradeLevel === '99';
    
    // Create select for each SELECTED subject area (even if no assessments)
    selectedSubjectAreas.forEach(function(subjectAreaId) {
      // Skip Theology (subject_area_id = 1) in MOY unless teacher grade
      if (isMoyTab && subjectAreaId === 1 && !isTeacherGrade) {
        console.log('Skipping Theology for MOY tab (non-teacher grade)');
        return;
      }
      
      const subjectData = assessmentsBySubject[subjectAreaId] || { 
        name: SUBJECT_NAMES[subjectAreaId] || `Subject ${subjectAreaId}`, 
        assessments: [] 
      };
      const selectId = `assessment_${subjectAreaId}`;
      
      // If no assessments are available for this subject area, show "N/A" instead of empty select
      if (subjectData.assessments.length === 0) {
        const naHtml = `
          <div class="col-md-6 mb-3" style="margin-left: 20px; display: block;">
            <label class="${labelClass}" style="display: block; margin-bottom: 5px;">${subjectData.name} Assessment</label>
            <div class="text-muted ml-5" style="padding-top: 6px; display: block;">N/A</div>
          </div>
        `;
        $targetContainer.append(naHtml);
        return; // Skip to next subject area
      }
      
      // If this is a past window, display the assessment name as text instead of a select
      if (isPastWindow) {
        // Find the selected assessment for this subject area
        let selectedAssessmentId = null;
        
        // First check stored selections (most recent)
        if (storedSelections && storedSelections[subjectAreaId]) {
          selectedAssessmentId = storedSelections[subjectAreaId];
        }
        // Then check selectedAssessmentIds array
        if (!selectedAssessmentId && selectedAssessmentIds && selectedAssessmentIds.length > 0) {
          // Find assessment in the current subject area's assessments that matches an ID in selectedAssessmentIds
          const matchingAssessment = subjectData.assessments.find(function(a) {
            return selectedAssessmentIds.includes(a.id);
          });
          if (matchingAssessment) {
            selectedAssessmentId = matchingAssessment.id;
          }
        }
        
        // Find the assessment name
        let assessmentName = 'N/A';
        if (selectedAssessmentId) {
          // First try to find in the current subject's assessments
          let selectedAssessment = subjectData.assessments.find(function(a) { return a.id == selectedAssessmentId; });
          // If not found, search all assessments
          if (!selectedAssessment) {
            selectedAssessment = assessments.find(function(a) { return a.id == selectedAssessmentId && a.subject_area_id == subjectAreaId; });
          }
          if (selectedAssessment) {
            assessmentName = selectedAssessment.name;
          }
        }
        
        const pastWindowHtml = `
          <div class="col-md-6 mb-3" style="margin-left: 20px; display: block;">
            <label class="${labelClass}" style="display: block; margin-bottom: 5px;">${subjectData.name} Assessment</label>
            <div class="text-muted ml-5" style="padding-top: 6px; display: block;">${assessmentName}</div>
          </div>
        `;
        $targetContainer.append(pastWindowHtml);
        return; // Skip to next subject area
      }
      
      let selectHtml = `
        <div class="col-md-6 mb-3" style="margin-left: 20px; display: block;">
          <label for="${selectId}" class="${labelClass}" style="display: block; margin-bottom: 5px;">${subjectData.name} Assessment *</label>
          <select id="${selectId}" name="testing_section[assessment_ids][]" class="form-control select2 assessment-select" data-subject-area-id="${subjectAreaId}" required ${disabledAttr} style="display: block; width: 100%;">
            <option value="">Select ${subjectData.name} Assessment</option>
      `;
      
      console.log('Rendering assessments for subject', subjectAreaId, ':', subjectData.assessments.length, 'assessments');
      subjectData.assessments.forEach(function(assessment) {
        console.log('  Adding option for assessment:', assessment.id, assessment.name);
        // Check both the array and stored selections object
        let isSelected = selectedAssessmentIds.includes(assessment.id);
        if (!isSelected && storedSelections && storedSelections[subjectAreaId] == assessment.id) {
          isSelected = true;
        }
        selectHtml += `<option value="${assessment.id}" ${isSelected ? 'selected' : ''}>${assessment.name}</option>`;
      });
      console.log('Select HTML length:', selectHtml.length, 'characters');
      
      selectHtml += `
          </select>
        </div>
      `;
      
      $targetContainer.append(selectHtml);
    });
    
    // Initialize select2 for new selects - use a small delay to ensure DOM is ready
    setTimeout(function() {
      $targetContainer.find('.assessment-select').each(function() {
        const $select = $(this);
        const subjectAreaId = $select.data('subject-area-id');
        
        // Ensure the select and its container have proper display
        $select.css('display', 'block').css('width', '100%');
        $select.closest('.col-md-6').css('display', 'block');
        
        // Check if this specific select's tab pane has a status record
        const $selectPane = $select.closest('.tab-pane');
        const selectHasStatus = $selectPane.length > 0 && $selectPane.data('has-status') === true;
        const selectIsPast = $selectPane.length > 0 && $selectPane.data('is-past') === true;
        
        $select.select2({
          theme: "bootstrap4",
          disabled: (selectHasStatus || selectIsPast), // Pass disabled state to select2
          width: '100%', // Ensure select2 takes full width
          minimumResultsForSearch: 0, // Always show search box (allows typing to filter)
          dropdownAutoWidth: false,
          dropdownCssClass: 'assessment-select-dropdown' // Add class for custom styling
        });
        
        // Add custom CSS for scrollable dropdown
        if (!$('#assessment-select-dropdown-style').length) {
          $('head').append(`
            <style id="assessment-select-dropdown-style">
              .assessment-select-dropdown .select2-results__options {
                max-height: 300px;
                overflow-y: auto;
              }
            </style>
          `);
        }
        
        // Store selection when changed
        $select.on('change', function() {
          const selectedValue = $(this).val();
          const $pane = $select.closest('.tab-pane');
          if ($pane.length > 0) {
            let storedSelections = $pane.data('stored-selections') || {};
            if (selectedValue) {
              storedSelections[subjectAreaId] = selectedValue;
            } else {
              delete storedSelections[subjectAreaId];
            }
            $pane.data('stored-selections', storedSelections);
            console.log('Updated stored selections for tab:', storedSelections);
          }
        });
      });
    }, 50); // Small delay to ensure DOM is fully rendered
    
    // Show the container and section - ensure display is set
    $targetContainer.css('display', 'block').show();
    
    // Also ensure parent row is visible if it exists and has proper display
    const $parentRow = $targetContainer.closest('.row.assessment-selects');
    if ($parentRow.length > 0) {
      $parentRow.css({
        'display': 'flex',
        'flex-wrap': 'wrap',
        'width': '100%'
      }).show();
      
      // Ensure all col-md-6 children have proper display
      $parentRow.find('.col-md-6').css('display', 'block');
    }
    
    if (!$targetContainer.closest('.tab-pane').length) {
      // Only show assessmentsSection if not in a tab
      $('#assessmentsSection').show();
    }
    
    console.log('Assessment selects rendered. Container display:', $targetContainer.css('display'), 'Parent row display:', $parentRow.length > 0 ? $parentRow.css('display') : 'N/A');
  }
  
  // Handle tab switching - refresh assessments for the new tab
  $(document).on('shown.bs.tab', '#testing-window-tabs button[data-bs-toggle="tab"]', function(e) {
    // Wait a moment for Bootstrap to finish showing the tab
    setTimeout(function() {
      // Get current selections
      const selectedSubjectAreas = [];
      $('.subject-area-checkbox:checked').each(function() {
        selectedSubjectAreas.push(parseInt($(this).val()));
      });
      const testingCenterId = $('#subjectAreaSection').data('testing-center-id');
      const gradeLevel = $('.grade-level-select').val();
      const isPaperTest = $('#testing_section_is_paper_test').is(':checked');
      
      // Only refresh if we have the required selections
      if (gradeLevel && selectedSubjectAreas.length > 0 && testingCenterId) {
        window.updateAssessments();
      } else {
        // Show message in the new tab if selections aren't ready
        const $newPane = $($(e.target).data('bs-target'));
        const $container = $newPane.find('.assessment-selects .assessment-content');
        if ($container.length > 0) {
          $container.html('<div class="text-muted pl-3 pt-2">Select grade level and subject areas to load assessments.</div>');
        }
      }
    }, 50);
  });
});
